import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSettings } from "../hooks/useAppSettings.tsx";
import { useSelector } from "react-redux";
import { RootState } from "../store/index.ts";
import AdminDashboard from "./dashboard/AdminDashboard.tsx";

const Dashboard = () => {
  useAppSettings();
  const { user } = useSelector((state: RootState) => state.auth);

  if (user.rol === "Contador")
    return <Navigate to="colaboradores" />;

  if (
    user.rol === "Administrador" ||
    user.rol === "Talento humano" ||
    user.rol === "Reclutador" ||
    user.rol === "Administrador-" ||
    user.rol === "Lider de sucursal"
  ) {
    return <AdminDashboard rol={user.rol} />;
  }

  if (user.rol === "Reclutamiento") {
    return <Navigate to="/vacantes" />;
  }

  if (user.rol === "Trabajador") {
    return <Navigate to={`mi-expediente`} />;
  }

  if (user.rol === "Reclutador/Archivos") {
    return <Navigate to={`solicitudes`} />;
  }

  if (user.rol === "Reloj checador") {
    return <Navigate to={`reloj-checador`} />;
  }

  if (user.rol === "Capacitación y Cultura") {
    return <Navigate to={`birthdates`} />;
  }

  if(user.rol === "Líder de líderes") return <Navigate to={`sucursales`} />;
};

export default Dashboard;
